import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'kv'})
export class KvPipe implements PipeTransform {
	transform(value): any {
		// console.log({kv: value});
		const keys = [];
		for (const key in value) {
			// console.log({key: key});
			keys.push({key: key, value: value[key]});
		}
		return keys;
	}
}
